<template>
	<modal body-classes="p-0" :show="open != null" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">แก้ไขผู้ใช้งาน</h2>
			</template>
			<template v-if="open">
				<form @submit.prevent="editUser">
					<base-input
						label="ชื่อผู้ใช้งาน"
						placeholder="ชื่อผู้ใช้งาน"
						:value="open.username"
						readonly
						required
					/>
					<base-input type="password" label="รหัสผ่าน" placeholder="รหัสผ่าน" v-model="password" />

					<div class="row mt-4 mb-2" v-if="open.username !== 'admin'">
						<div class="col-md-6" v-for="(perm, v) in permissions" :key="v">
							<base-checkbox :value="v" v-model="perms[v]">
								{{ perm }}
							</base-checkbox>
						</div>
					</div>

					<base-button native-type="submit" type="default" class="mt-2" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import UserService from '../../services/user.service'

export default {
	props: ['open', 'permissions'],
	data() {
		return {
			loading: false,
			password: '',
			perms: {},
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		editUser() {
			this.loading = true
			UserService.editUser(this.open.username, {
				password: this.password,
				permissions: this.perms,
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('reloadUser')
					this.$emit('close')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	watch: {
		open(v) {
			if (v) {
				this.perms = {}
				for (let p in v.permissions) {
					this.perms[p] = v.permissions[p]
				}
			}
		},
	},
}
</script>
